
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples",
      function () {
        return require("private-next-pages/examples.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples"])
      });
    }
  